module.exports = "/templates/customersettings.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/customersettings.html
// module id = 444
// module chunks = 0